export class SrtStats {
  byteAvailRcvBuf: number;
  mbpsBandwidth: number;
  mbpsRecvRate: number;
  msRTT: number;
  pktRcvAvgBelatedTime: number;
  pktRcvBelated: number;
  pktRcvDrop: number;
  pktRcvLoss: number;
  pktRcvRetrans: number;
  pktRecv: number;


  /**
   * Constructor
   */

  constructor(byteAvailRcvBuf: number, mbpsBandwidth: number, mbpsRecvRate: number, msRTT: number, pktRcvAvgBelatedTime: number, pktRcvBelated: number, pktRcvDrop: number, pktRcvLoss: number, pktRcvRetrans: number, pktRecv: number) {
    this.byteAvailRcvBuf = byteAvailRcvBuf;
    this.mbpsBandwidth = mbpsBandwidth;
    this.mbpsRecvRate = mbpsRecvRate;
    this.msRTT = msRTT;
    this.pktRcvAvgBelatedTime = pktRcvAvgBelatedTime;
    this.pktRcvBelated = pktRcvBelated;
    this.pktRcvDrop = pktRcvDrop;
    this.pktRcvLoss = pktRcvLoss;
    this.pktRcvRetrans = pktRcvRetrans;
    this.pktRecv  = pktRecv ;
  }

}

export type SrtStatsStatus = 'Excellent' | 'Good' | 'Degraded';

export class SrtStatsUI {
  status: SrtStatsStatus;
  healthSummary: string;

  latency: string;
  receiveRate: string;
  bandwidth: string;

  bufferAvailable: string;

  packetLoss: string;
  droppedPackets: string;
  retransmissions: string;
  packetsReceived: string;

  /**
   * Constructor
   */
 
  constructor(status: SrtStatsStatus, healthSummary: string, latency: string, receiveRate: string, bandwidth: string, bufferAvailable: string, packetLoss: string, droppedPackets: string, retransmissions: string, packetsReceived: string) {
    this.status = status;
    this.healthSummary = healthSummary;
    this.latency = latency;
    this.receiveRate = receiveRate;
    this.bandwidth = bandwidth;
    this.bufferAvailable = bufferAvailable;
    this.packetLoss = packetLoss;
    this.droppedPackets = droppedPackets;
    this.retransmissions = retransmissions;
    this.packetsReceived = packetsReceived;
  }

  /**
   * Static Methods
   */

  static bytesToMB = (bytes: number): string =>
  `${(bytes / (1024 * 1024)).toFixed(1)} MB`;

  static mbpsToReadable = (mbps: number): string =>
    mbps >= 1000
      ? `${(mbps / 1000).toFixed(2)} Gbps`
      : `${mbps.toFixed(1)} Mbps`;

  static msToLatency = (ms: number): string =>
    ms < 1 ? `${Math.round(ms * 1000)} µs` : `${ms.toFixed(1)} ms`;

  static formatCount = (value: number): string =>
    value === 0
      ? "None"
      : value.toLocaleString();

  static evaluateHealth(stats: SrtStats): { status: SrtStatsStatus, summary: string } {
    if (stats.pktRcvLoss > 0 || stats.pktRcvDrop > 0) {
      return {
        status: "Degraded",
        summary: "Packet loss or drops detected",
      };
    }

    if (stats.msRTT > 100 || stats.pktRcvRetrans > 0) {
      return {
        status: "Good",
        summary: "Minor network recovery activity",
      };
    }

    return {
      status: "Excellent",
      summary: "No packet loss with low latency and high bandwidth headroom",
    };
  }

  static formatSrtStatsForUI(raw: SrtStats): SrtStatsUI {
  const health = this.evaluateHealth(raw);

  return {
    status: health.status,
    healthSummary: health.summary,

    latency: this.msToLatency(raw.msRTT),
    receiveRate: this.mbpsToReadable(raw.mbpsRecvRate),
    bandwidth: this.mbpsToReadable(raw.mbpsBandwidth),

    bufferAvailable: this.bytesToMB(raw.byteAvailRcvBuf),

    packetLoss: this.formatCount(raw.pktRcvLoss),
    droppedPackets: this.formatCount(raw.pktRcvDrop),
    retransmissions: this.formatCount(raw.pktRcvRetrans),
    packetsReceived: this.formatCount(raw.pktRecv),
  };
}

}